<script>
 import { onMount, tick } from 'svelte';
 import {headerBreakPoint} from "@util/constant";
let campaigJsonArray = [];
let widthY = 0
let addSendID = "common-sp-header-campaign"

onMount(async () => {
  const [activecampaign] = await Promise.all([
    fetch(`/assets_default/data/campaign_active.json`)
  ]);

  const campaignJson = await activecampaign.json();

  campaigJsonArray = campaignJson.item.slice(0,3);
  addSendID = widthY>headerBreakPoint ? "common-pc-header-campaign" : "common-sp-header-campaign"
  await tick();
});
</script>
<svelte:window bind:innerWidth={widthY} />

<div class="card spacing:bottom:40">
  {#each campaigJsonArray as cardObject}
    <a href={cardObject.url} class="card-block header-link-ga" id={addSendID}>
      <picture class="card-thumbnail">
        <img src={cardObject.image} alt={cardObject.title} width="84" height="84">
      </picture>
      <div class="card-item">
        <h3 class="card-title owd-heading:05">{cardObject.title}</h3>
        {#if cardObject.date}
          <p class="card-date owd-caption">{cardObject.date}</p>
        {/if}

        {#if cardObject.category}
          <ul class="card-hashtag">
            {#each cardObject.category as hashtag}
              <li class="owd-caption"># {hashtag}</li>
            {/each}
          </ul>
        {/if}
      </div>
    </a>
  {/each}
</div>
<div class="block:center">
  <a href="/campaign/" class="owd-button owd-button:large owd-button:secondary:white">キャンペーン一覧はこちら</a>
</div>


<style lang="scss">


  .card {
    padding: 16px 24px;
    // @include g.radius("md");
    position: relative;

    @include g.large() {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 40px;
      padding: 0;
      margin-bottom: 40px;
    }


    &-block {
      display: grid;
      grid-template-columns: 85px 1fr;
      gap: 16px;
      padding: 16px 10px 16px 0;
      text-decoration: none;
      border-bottom: 1px solid var(--black-opacity1);
      transition: .2s linear opacity;

      @include g.large() {
        gap: 16px;
      }

      @media (hover: hover) {
        &:hover {
          opacity: .6;
        }
      }
    }

    &-thumbnail {
      display: block;
      width: 100%;
      height: 85px;
      @include g.radius("sm");
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-title {
      margin-bottom: 12px;
    }

    &-date {
      margin-bottom: 8px;
    }

    &-hashtag {
      line-height: 0;
      li {
        display: inline-block;
        &:nth-child(n+2) {
          margin-left: 5px;
        }
      }
    }
  }
</style>
